import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
export default class WeekNumber extends React.Component {
    handleClick = (event)=>{
        if (this.props.onClick) {
            this.props.onClick(event);
        }
    };
    render() {
        const weekNumberClasses = {
            'react-datepicker__week-number': true,
            'react-datepicker__week-number--clickable': !!this.props.onClick
        };
        return /*#__PURE__*/ React.createElement("div", {
            className: cx(weekNumberClasses),
            "aria-label": `week-${this.props.weekNumber}`,
            onClick: this.handleClick
        }, this.props.weekNumber);
    }
}
WeekNumber.propTypes = {
    onClick: PropTypes.func,
    weekNumber: PropTypes.number.isRequired
};
